// Wizard draft persistence in localStorage (survives back/refresh)
const KEY = "mm_wizard_draft_v1";

export const emptyDraft = () => ({
  kit_qty: null,
  gift_packages: 0,
  add_ons: {},
  source: null,
  discount: null, // {type:"first_order", email, pct}
  photos: [], // {photo_id, preview_url, preview_w, preview_h, original_w, original_h, filename, crop, cropPos, zoom, rotation, copies, approved}
  customer: { name: "", email: "" },
  address: { line1: "", line2: "", city: "", state: "", postal_code: "", country: "US" },
});

export function loadDraft() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return emptyDraft();
    return { ...emptyDraft(), ...JSON.parse(raw) };
  } catch {
    return emptyDraft();
  }
}

export function saveDraft(draft) {
  try {
    localStorage.setItem(KEY, JSON.stringify(draft));
  } catch {
    /* storage unavailable (e.g. Safari private mode / quota) — draft persistence is best-effort */
  }
}

export function clearDraft() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* storage unavailable — nothing to clear */
  }
}
